import { Box, Flex, Text } from "@chakra-ui/react";
import { NostrEvent } from "nostr-tools";

import UserAvatarLink from "../user/user-avatar-link";
import UserLink from "../user/user-link";
import Message, { MessageProps } from "./message";

export type MessageGroupProps = {
  messages: NostrEvent[];
  reverse?: boolean;
  isSelf?: boolean;
  renderContent: MessageProps["renderContent"];
  renderActions?: MessageProps["renderActions"];
};

export default function MessagesGroup({
  messages,
  reverse = false,
  isSelf = false,
  renderContent,
  renderActions,
}: MessageGroupProps) {
  const first = reverse ? messages[messages.length - 1] : messages[0];

  return (
    <Flex direction={reverse ? "column-reverse" : "column"} gap="0.5">
      {/* Show sender info for non-self messages at group start */}
      {!isSelf && first && (
        <Flex px="3" gap="2" alignItems="center" mt="2">
          <UserAvatarLink pubkey={first.pubkey} size="xs" />
          <UserLink pubkey={first.pubkey} fontWeight="semibold" fontSize="sm" />
        </Flex>
      )}
      {messages.map((message) => (
        <Message
          key={message.id}
          message={message}
          showHeader={false}
          isSelf={isSelf}
          renderContent={renderContent}
          renderActions={renderActions}
        />
      ))}
    </Flex>
  );
}
